import { validatePresence, validateFormat } from 'ember-changeset-validations/validators';
import isRemovedString from 'garaje/helpers/is-removed-string';
import { isValidDate } from 'garaje/utils/date-format';
import { SENSITIVE_RESPONSE_STRINGS } from 'garaje/utils/enums';

export default function buildFlowFieldValidations(field) {
  const validations = [];

  if (field.required && !(field.allowVisitorRespondents ?? true)) {
    validations.push(
      validatePresence({
        presence: true,
        message: 'This is a required field',
      }),
    );
  }

  if (field.isEmail) {
    validations.push(
      validateFormat({
        type: 'email',
        allowBlank: true,
        message: 'Please enter a valid email address',
      }),
    );
  }

  if (field.isDate) {
    validations.push(function validateDateValue(key, newValue) {
      if (!newValue) return true;
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!isoDateRegex.test(newValue)) {
        return 'Please enter a valid date';
      }
      const [year, month, day] = newValue.split('-').map(Number);
      if (!isValidDate(day, month, year)) {
        return 'Please enter a valid date';
      }
      return true;
    });
  }

  if (field.isSingleSelection) {
    // Add validation to check if the value is a valid field option
    validations.push(function validateDropdownOption(key, newValue) {
      const options = field.options;

      if (!newValue) return true;
      if (!options || options.length === 0) return true;
      if (isRemovedString(newValue)) return true;
      // A masked sensitive value isn't a real option; skip rather than flag it.
      if (newValue === SENSITIVE_RESPONSE_STRINGS.PLACEHOLDER) return true;

      const validOptionValues = options.flatMap((option) => [
        option.value,
        ...Object.values(option.customTranslations?.value ?? {}),
      ]);
      const isValidOption = validOptionValues.includes(newValue);

      return isValidOption || 'This option is no longer available. Please choose another.';
    });
  }

  return { value: validations };
}
